<div class="nearby-sales">
    <ev-grid-table [gridModel]="displayTemplate">
        <ev-th>
            <ev-td area="estate-type-icon"></ev-td>

            @for(column of headers; track column.name) { @if(column?.isSortable) {
            <ev-td
                class="header-column"
                [area]="column.prop"
                (click)="updateSort(column.prop)"
                [isSelectable]="true"
                [textAlignment]="column.textAlignment ?? 'left'"
                [selected]="sortConfig().sortOption.prop == column.prop"
            >
                {{ column.name.toUpperCase() }}

                @if(column.prop === 'residentialMeasuredArea') {
                <span
                    class="info-icon-wrapper"
                    (click)="toggleResidentialMeasuredAreaTooltip($event)"
                    (clickOutside)="residentialMeasuredAreaTooltipVisible = false"
                >
                    <div class="info-icon"></div>
                </span>

                <ev_tooltip
                    [visible]="residentialMeasuredAreaTooltipVisible"
                    [left]="-139"
                    [bottom]="33"
                    [arrow]="'bottom'"
                    [arrowBottomAlign]="-8"
                    [arrowAlignLeft]="162"
                    (close)="residentialMeasuredAreaTooltipVisible = false"
                    (click)="onHeaderTooltipClick($event)"
                    title="m²"
                >
                    <div class="header-tooltip">Areal oppgis i BRA-i, eller P-rom dersom BRA-i ikke er tilgjengelig.</div>
                </ev_tooltip>
                }
            </ev-td>
            } @else {
            <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                {{ column.name.toUpperCase() }}
            </ev-td>
            } }
        </ev-th>

        @if (tableData()) { @for(rowData of tableData(); track $index) {
        <ev-tr class="ev-row" [hasRowContent]="false">
            <ev-td area="estate-type-icon" column [title]="rowData.estateType">
                <span class="column-data"><div class="estate-type" [ngClass]="rowData.estateType"></div></span>
            </ev-td>
            <ev-td area="sortDate" header="Dato" column title="Dato" [fontBold]="sortConfig().sortOption.prop == 'sortDate'">
                <div class="column-data">{{ rowData.sortDate | date : "dd.MM.yyyy" }}</div>
            </ev-td>
            <ev-td area="concatenatedAddress" header="Adresse" column title="Adresse" [fontBold]="sortConfig().sortOption.prop == 'concatenatedAddress'">
                <div class="column-data">
                    @if(rowData.unitId) {
                    <a target="_blank" [routerLink]="['/resolve/infopage']" [queryParams]="{ unitID: rowData.unitId }">
                        {{ rowData.concatenatedAddress | defaultconvert }}
                    </a>
                    } @else {
                    {{ rowData.concatenatedAddress | defaultconvert }}
                    }
                </div>
            </ev-td>
            <ev-td area="ownershipType" header="Eieform" column title="Eieform" [fontBold]="sortConfig().sortOption.prop == 'ownershipType'">
                <div class="column-data">{{ rowData.ownershipType | defaultconvert }}</div>
            </ev-td>
            <ev-td area="residentialMeasuredArea" header="m²" column title="m²" [fontBold]="sortConfig().sortOption.prop == 'residentialMeasuredArea'">
                <div class="column-data">{{ rowData.residentialMeasuredArea | thousandize | unit : " m²" }}</div>
            </ev-td>
            <ev-td area="floor" header="Etg" column title="Etg" [fontBold]="sortConfig().sortOption.prop == 'floor'">
                <div class="column-data">{{ rowData.floor | defaultconvert }}</div>
            </ev-td>
            <ev-td area="numberOfBedrooms" header="Soverom" column title="Soverom" [fontBold]="sortConfig().sortOption.prop == 'numberOfBedrooms'">
                <div class="column-data">{{ rowData.estateType == "Leilighet" ? rowData.numberOfBedrooms : (rowData.rooms | defaultconvert) }}</div>
            </ev-td>
            <ev-td area="buildYear" header="Byggeår" column title="Byggeår" [fontBold]="sortConfig().sortOption.prop == 'buildYear'">
                <div class="column-data">{{ rowData.buildYear | defaultconvert }}</div>
            </ev-td>
            <ev-td area="price" header="Pris" column title="Pris" [fontBold]="sortConfig().sortOption.prop == 'price'">
                <div class="column-data">{{ rowData.price | thousandize }}</div>
            </ev-td>
            <ev-td area="estateAgent" header="Megler" column title="Megler" [fontBold]="sortConfig().sortOption.prop == 'estateAgent'">
                <div class="column-data">{{ rowData.estateAgent }}</div>
            </ev-td>
        </ev-tr>
        } }
    </ev-grid-table>

    @if(originalData()?.length > rowsToShow) {
    <div class="show-more-button">
        <button (click)="onShowMore()">Vis flere</button>
    </div>
    }
</div>
